module.exports = __webpack_public_path__ + "static/MapleAve.86a6f554.jpg";